/**
 * LatestArticles — the newest blog articles on the homepage, using the
 * blog's own article cards.
 */
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ArticleGrid } from "@modules/shop/components/Blog/ArticleGrid";
import {
  SectionHeader,
  SectionLinkLabel,
  sectionLinkClass,
} from "./SectionHeader";
import type { ComponentProps } from "react";

interface LatestArticlesProps {
  locale: string;
  articles: ComponentProps<typeof ArticleGrid>["articles"];
}

export function LatestArticles({
  locale,
  articles,
}: Readonly<LatestArticlesProps>) {
  const { t } = useTranslation();

  if (articles.length === 0) return null;

  return (
    <section className="px-4 py-14 sm:px-6 lg:px-8 max-mobile:py-10">
      <div className="mx-auto max-w-7xl">
        <SectionHeader
          title={t("Homepage.latestArticles")}
          link={
            <Link
              to="/$locale/blog"
              params={{ locale }}
              className={sectionLinkClass}
            >
              <SectionLinkLabel label={t("Homepage.viewAll")} />
            </Link>
          }
        />
        <div data-reveal="items">
          <ArticleGrid articles={articles} locale={locale} headingLevel="h3" />
        </div>
      </div>
    </section>
  );
}
